// import { Store } from 'react-notifications-component';
// import 'react-notifications-component/dist/theme.css';
// import 'animate.css';

// const notification = ({
//   title, message, type, onRemoval = () => {}, duration = 5000
// }) => {
//   const id = Store.addNotification({
//     title: title || '',
//     message: message || '',
//     type: type || 'warning', // 'default', 'success', 'info', 'warning'
//     container: 'top-center', // where to position the notifications
//     animationIn: ['animate__animated', 'animate__fadeIn'],
//     animationOut: ['animate__animated', 'animate__fadeOut'],
//     dismiss: {
//       duration,
//       showIcon: true,
//       onScreen: true,
//       pauseOnHover: true
//     },
//     onRemoval
//   });

//   return { id, Store };
// };

// export default notification;

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Initialize Toastify (should be placed in your app's entry point, e.g., App.js)
// toast.configure();

const notification = ({
  message = '',
  type = 'info', // 'info', 'success', 'warning', 'error', 'default'
  position = 'top-center', // Customize the position
  duration = 5000, // Auto-close duration in milliseconds
  onClose = () => {} // Callback on notification close
} = {}) => {
  const toastId = toast(message, {
    type: type === "danger" ? "error" : type,
    position,
    autoClose: duration,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    onClose
  });

  return toastId;
};

export default notification;

